module.exports = __webpack_public_path__ + "media/images/admin/logo-a32bb39cdd3d900d966caffda4982384.png";